import SignUpConfigmModal from './SignUpConfirmModal';

export default SignUpConfigmModal;


// WEBPACK FOOTER //
// ./src/components/SignUpConfirmModal/index.jsx